
import { Component, Inject, Vue } from 'vue-property-decorator';
import LabelRepository from '@/repositories/content/label/LabelRepository';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class LabelListScreen extends Vue {
    @Inject()
    private readonly labelRepository!: LabelRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.label.textNl'),
                align: 'left',
                value: 'textNl',
                sortable: true,
            },
            {
                text: this.$t('crud.label.textEn'),
                value: 'textEn',
                sortable: true,
            },
        ];
    }
}
